// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"a4e08b22","106":"bf4bb67c","318":"c2d6f2d4","995":"343a3af4"}[chunkId] + ".chunk.css";
};